import { render, staticRenderFns } from "./studentroster.vue?vue&type=template&id=2fa9fe5e&scoped=true"
import script from "./studentroster.vue?vue&type=script&lang=js"
export * from "./studentroster.vue?vue&type=script&lang=js"
import style0 from "./studentroster.vue?vue&type=style&index=0&id=2fa9fe5e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa9fe5e",
  null
  
)

export default component.exports